import { publicEnvVars } from "./config"
import { Maybe } from "../graphql/generated-types"

export const gaPageView = (url: string, userId: Maybe<string>): void => {
    if (!publicEnvVars.GOOGLE_ANALYTICS_ID) {
        return
    }

    if (window && window.gtag) {
        window.gtag("config", publicEnvVars.GOOGLE_ANALYTICS_ID, {
            page_path: url,
            user_id: userId,
        })
    }
}
